// ============================================================================
// Table Columns: Permissions
// Key: permissions
// Generated file. Do not edit manually.
// ============================================================================

// #region Imports
import {
	cellRenderer,
	type EntityTableConfig,
	enumRenderer,
	relationCountRenderer,
} from '../../entity-config-runtime/entity-table-config'
import type {
	PermissionSummary,
	RolePermissionDto,
	RoleSummary,
} from '../api/backstage.schemas'
import {
	ApplicationScope,
	EntityScope,
	PermissionName,
} from '../api/backstage.schemas'
// #endregion

// #region Entity List Columns
export const permissionsListColumnsConfig = {
	columns: [
		enumRenderer('name', PermissionName, 'PermissionName'),
		relationCountRenderer('roleCount', 'roles'),
		'modifiedBy',
		cellRenderer('modifiedUtc', 'dateTime'),
	],
	actions: [
		{
			type: 'link',
			id: 'id',
			label: 'tables_actions_detail',
			icon: 'ArrowRight',
			style: 'link',
			href: (row: PermissionSummary) => `/permissions/${row.id}/details`,
		},
	],
} as const satisfies EntityTableConfig<PermissionSummary>
// #endregion

// #region Relation List Columns
// #region Relation: Roles
export const permissionsRelationsRolesAssignedColumnsConfig = {
	columns: [
		'roleName',
		enumRenderer('permissionName', PermissionName, 'PermissionName'),
	],
} as const satisfies EntityTableConfig<RolePermissionDto>
export const permissionsRelationsRolesAvailableColumnsConfig = {
	columns: [
		'modifiedBy',
		cellRenderer('modifiedUtc', 'dateTime'),
		'name',
		enumRenderer('entityScope', EntityScope, 'EntityScope'),
		enumRenderer('applicationScope', ApplicationScope, 'ApplicationScope'),
		cellRenderer('isDefault', 'boolean'),
		cellRenderer('isBaseRole', 'boolean'),
		'userGroup',
		cellRenderer('permissionCount', 'number'),
		cellRenderer('userCount', 'number'),
		cellRenderer('templateCount', 'number'),
	],
} as const satisfies EntityTableConfig<RoleSummary>
// #endregion
// #endregion

// #region Columns Config Export
export const permissionsColumnsConfig = {
	list: permissionsListColumnsConfig,
	relations: {
		roles: {
			assigned: permissionsRelationsRolesAssignedColumnsConfig,
			available: permissionsRelationsRolesAvailableColumnsConfig,
		},
	},
} as const
// #endregion
